export default function PurchaseFail() {
  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <h1 className="text-2xl font-bold text-red-500">Purchase Failed</h1>
    </div>
  );
}
